export default __webpack_public_path__ + "static/media/ic-calenda.adc9366e.svg";